import { Extension } from '@tiptap/react'
import { Plugin, PluginKey } from '@tiptap/pm/state'
import { Decoration, DecorationSet } from '@tiptap/pm/view'

const activeBlockPluginKey = new PluginKey('activeBlockDecoration')

export const ActiveBlockDecoration = Extension.create({
  name: 'activeBlockDecoration',

  addProseMirrorPlugins() {
    return [
      new Plugin({
        key: activeBlockPluginKey,

        state: {
          init(): { hasFocus: boolean } {
            return { hasFocus: false }
          },
          apply(tr, value): { hasFocus: boolean } {
            const focus = tr.getMeta('abd:focus')
            if (focus !== undefined) return { hasFocus: focus }
            return value
          },
        },

        props: {
          handleDOMEvents: {
            focus(view) {
              view.dispatch(view.state.tr.setMeta('abd:focus', true))
              return false
            },
            blur(view) {
              view.dispatch(view.state.tr.setMeta('abd:focus', false))
              return false
            },
          },

          decorations(state) {
            const ps = activeBlockPluginKey.getState(state) as { hasFocus: boolean } | undefined
            if (!ps?.hasFocus) return DecorationSet.empty

            const { selection, doc } = state
            const decorations: Decoration[] = []

            const $pos = selection.$head
            const depth = $pos.depth

            if (depth > 0) {
              const blockStart = $pos.start(depth) - 1
              const blockEnd = $pos.end(depth) + 1
              decorations.push(
                Decoration.node(blockStart, blockEnd, {
                  class: 'is-active-block',
                })
              )
            } else {
              const pos = $pos.pos
              doc.nodesBetween(pos, pos, (node, nodePos) => {
                if (node.isBlock && node.isTextblock) {
                  decorations.push(
                    Decoration.node(nodePos, nodePos + node.nodeSize, {
                      class: 'is-active-block',
                    })
                  )
                  return false
                }
                return true
              })
            }

            return DecorationSet.create(doc, decorations)
          },
        },
      }),
    ]
  },
})
